import { Checkbox, DatePicker, Input, Modal, Tabs } from "antd";
import { useEffect, useState } from "react";
import { Button, ButtonBase, CircularProgress } from "@mui/material";
import InHouseInterestBox from "./InHouseInterestBox";
import ImageInput from "./ImageInput";
import AddDeclarationModal from "./AddDeclarationModal";
import CropPopup from "./CropPopUp";
import { Controller, FormProvider, useForm } from "react-hook-form";
import dayjs from "dayjs";
import { useContext } from "react";
import { AuthenticationContext } from "../../App";
import axios from "../../axios/axios";
import { apiAxios } from "../../axios/axios";
import { useRef } from "react";
import { useQuery } from "react-query";
import InHouseSwitchBox from "./InHouseSwitchBox";
import InHouseScheduleBox from "./InHouseScheduleBox";
import LoaderComp from "../../components/LoaderComp";
import { toast } from "react-toastify";
const items = [
    {
        key: 0,
        label: `Low Tier`,
        schedDis: true,
    },
    {
        key: 1,
        label: `High Tier`,
        schedDis: true,
    },
];
const IMAGE_BASE_URL = "https://api.ohhto.com";
async function dataURItoBlob(url) {
    return await (await fetch(url)).blob();
}
const InHouseModal = (props) => {
    const {
        settingsData,
        setinHouseModal,
        getLoanProduct,
        inHouseEdit,
        applyFilters,
        settingsFilters,
        agentId,
    } = props.context;
    const { authData } = useContext(AuthenticationContext);
    const methods = useForm({
        defaultValues: {
            name: "",
            Interest: [
                {
                    id: "",
                    // interest: "",
                    startDate: "",
                    endDate: "",
                    // remarks1: "",
                    // remarks2: "",
                    remarks: [],
                    minimum_loan_amount: "",
                    maximum_loan_amount: "",
                    check_val: "0",
                    view: false,
                },
            ],
            schedule: [
                {
                    id: "",
                    // interest: "",
                    startDate: "",
                    endDate: "",
                    // remarks1: "",
                    // remarks2: "",
                    remarks: [],
                    minimum_loan_amount: "",
                    maximum_loan_amount: "",
                    check_val: "0",
                    view: false,
                },
            ],
        },
    });
    const {
        register,
        getValues,
        handleSubmit,
        setValue,
        control,
        formState: { errors },
    } = methods;
    const [filterVal, setFilterVal] = useState({
        vehicle: "",
        category: "", //check
        productType: "",
        loanType: "", //check
        usage: "", //check
        scheme: "", //check
        motorType: "", //check
        ltv: "",
        approvalTime: "",
        featured: 0,
        collect_first_installment: "0",
        form_data: []
    });
    const [overRideModal, setOverRideModal] = useState(false);
    const [submitBtnLoad, setsubmitBtnLoad] = useState(false);
    const [makeSchedule, setmakeSchedule] = useState({
        scd0: false,
        scd1: false,
    });
    const [editForm, setEditForm] = useState({
        edit: false,
        id: "",
    });
    const [imgErr, setImgErr] = useState(false);
    const imgPosRef = useRef(null);
    const [settingsIndex, setSettingsIndex] = useState(
        settingsFilters !== undefined &&
            settingsFilters !== null &&
            Object.keys(settingsFilters)?.length > 0
            ? settingsFilters
            : {
                veh: 0,
                cat: 0,
                typ: 0,
                schm: 0,
            }
    );
    const [productIcon, setProductIcon] = useState(null);
    const [showCrop, setShowCrop] = useState(false);
    const [croppedImage, setCroppedImage] = useState(false);
    const [image, setImage] = useState(null);
    const [interestKey, setinterestKey] = useState(0);
    const [intTabPos, setIntTabPos] = useState(0);
    const [animClass, setAnimClass] = useState("invisible translate-x-[100%]");

    const [showDeclarationModal, setShowDeclarationModal] = useState(false);
    const [declarationFormData, setDeclarationFormData] = useState([]);

    const {
        isLoading,
        isFetching,
        data: checkData,
        refetch: checkApiFetch,
    } = useQuery(
        [
            "checkApi",
            filterVal.vehicle,
            filterVal.category,
            filterVal.loanType,
            filterVal.usage,
            filterVal.scheme,
            filterVal.motorType,
            filterVal.collect_first_installment,
            filterVal?.approvalTime,
            filterVal?.ltv,
        ],
        async ({ queryKey }) => {
            const [
                ,
                vehicle,
                category,
                loanType,
                usage,
                scheme,
                motorType,
                collect_first_installment,
                approvalTime,
                ltv,
            ] = queryKey;
            const postData = {
                vehicle,
                category,
                loanType,
                usage,
                scheme,
                motorType,
                collect_first_installment,
                approvalTime,
                ltv,
            };
            const resp = await axios.post("/loan/product/check", postData, {
                headers: {
                    Authorization: `Bearer ${authData?.token}`,
                },
            });
            if (resp?.data?.isExist && !editForm.edit) {
                setOverRideModal(true);
                const existData = {
                    isExist: resp?.data?.isExist,
                    ...resp?.data?.data,
                };
                return existData;
            }
            return resp?.data;
        },
        {
            refetchOnWindowFocus: false,
            enabled: filterVal.category !== "" && !inHouseEdit.prodEdit,
        }
    );
    const { isFetching: pInfoFetch } = useQuery(
        "product-info",
        async () => {
            const resp = await axios.get(`/loan/product/info/${inHouseEdit.id}`, {
                headers: {
                    Authorization: `Bearer ${authData?.token}`,
                },
            });
            const respData = resp?.data?.data;

            setTimeout(() => {
                let data = { ...respData };
                const parsedFormData = typeof data?.form_data === "string"
                    ? JSON.parse(data.form_data)
                    : data?.form_data;
                setDeclarationFormData(parsedFormData);
                console.log("time=========", parsedFormData)
            }, 500)

            if (respData) {
                setValue("name", respData?.name);
                setEditForm({
                    ...editForm,
                    edit: true,
                    id: respData.id,
                });
                setFilterVal({
                    ...filterVal,
                    approvalTime: respData.approvalTime,
                    vehicle: respData.vehicle,
                    category: respData.category,
                    loanType: respData.loanType,
                    ltv: respData.ltv,
                    motorType: respData.motorType,
                    productType: respData.productType,
                    scheme: respData.scheme,
                    featured: respData.featured,
                    usage: respData.usage,
                    collect_first_installment:
                        respData?.collect_first_installment !== undefined
                            ? respData?.collect_first_installment
                            : "0",
                });
                setProductIcon(respData.icon);
                respData.interests.forEach((item, idx) => {
                    let startDate = item.startDate ? dayjs(item.startDate) : "";
                    let endDate = item.endDate ? dayjs(item.endDate) : "";
                    setValue(`Interest.[${idx}].id`, item.id);
                    setValue(`Interest.[${idx}].interest`, item.interest);
                    setValue(`Interest.[${idx}].startDate`, startDate);
                    setValue(`Interest.[${idx}].endDate`, endDate);
                    setValue(`Interest.[${idx}].remarks1`, item.remarks1);
                    setValue(`Interest.[${idx}].remarks2`, item.remarks2);
                    setValue(
                        `Interest.[${idx}].minimum_loan_amount`,
                        item.minimum_loan_amount
                    );
                    setValue(`Interest.[${idx}].check_val`, item.admin_fee_status);
                    setValue(`Interest.[${idx}].view`, true);
                    if (item.admin_fee_status === "1") {
                        setValue(
                            `Interest.[${idx}].maximum_loan_amount`,
                            item.maximum_loan_amount
                        );
                    }
                    items[idx].schedDis = false;
                    if (item.schedule) {
                        const schedule = item.schedule;
                        let startDate = schedule.startDate ? dayjs(schedule.startDate) : "";
                        let endDate = schedule.endDate ? dayjs(schedule.endDate) : "";
                        let scheduleDate = schedule.scheduleDate
                            ? dayjs(schedule.scheduleDate)
                            : "";
                        setValue(`Schedule.[${idx}].interest`, schedule.interest);
                        setValue(`Schedule.[${idx}].startDate`, startDate);
                        setValue(`Schedule.[${idx}].endDate`, endDate);
                        setValue(`Schedule.[${idx}].scheduleDate`, scheduleDate);
                        setValue(`Schedule.[${idx}].remarks1`, schedule.remarks1);
                        setValue(`Schedule.[${idx}].remarks2`, schedule.remarks2);
                        setValue(
                            `Schedule.[${idx}].minimum_loan_amount`,
                            schedule.minimum_loan_amount
                        );
                        setValue(`Schedule.[${idx}].check_val`, schedule.admin_fee_status);
                        setValue(`Schedule.[${idx}].view`, true);
                        if (schedule.admin_fee_status === "1") {
                            setValue(
                                `Schedule.[${idx}].maximum_loan_amount`,
                                schedule.maximum_loan_amount
                            );
                        }
                        setmakeSchedule((prevState) => ({
                            ...prevState,
                            [`scd${idx}`]: true,
                        }));
                    }
                });
            }
            return respData;
        },
        {
            refetchOnWindowFocus: false,
            enabled: inHouseEdit.prodEdit,
        }
    );
    const settingsHandle = (idx, title, tabId) => {
        switch (title) {
            case "vehicle":
                setSettingsIndex({ ...settingsIndex, veh: idx, typ: 0 });
                setFilterVal({
                    ...filterVal,
                    vehicle: settingsData.vehicles[idx].id,
                });
                break;
            case "category":
                setSettingsIndex({ ...settingsIndex, cat: idx, typ: 0 });
                setFilterVal({
                    ...filterVal,
                    category: tabId,
                    loanType: settingsData.categories[idx].types[0].id,
                    scheme: settingsData.categories[idx].types[0].schemes[0].id,
                });
                break;
            case "type":
                setSettingsIndex({ ...settingsIndex, typ: idx, schm: 0 });
                setFilterVal({
                    ...filterVal,
                    loanType: tabId,
                    scheme:
                        settingsData.categories[settingsIndex.cat].types[idx].schemes[0].id,
                });
                break;
            case "scheme":
                setSettingsIndex({ ...settingsIndex, schm: idx });
                setFilterVal({
                    ...filterVal,
                    loanType:
                        settingsData.categories[settingsIndex.cat].types[settingsIndex.typ]
                            .id,
                    scheme: tabId,
                });
                break;
            case "motor":
                setFilterVal({
                    ...filterVal,
                    motorType: tabId,
                });
                break;
            case "usage":
                setFilterVal({
                    ...filterVal,
                    usage: tabId,
                });
                break;
            case "collect first installment?":
                setFilterVal({
                    ...filterVal,
                    collect_first_installment: tabId,
                });
                break;
            default:
                break;
        }
    };

    const onImageChange = (event) => {
        if (event.target.files && event.target.files[0]) {
            setShowCrop(true);
            setImage(URL.createObjectURL(event.target.files[0]));
        }
    };
    const createLoanProduct = async (data) => {
        let err = 0;
        if (!imgErr) {
            err++;
        }
        await checkApiFetch();
        let isExist = checkData ? checkData.isExist : null;
        if (err !== 0 && (!isExist || editForm.edit)) {
            //setsubmitBtnLoad(true);
            const { name, Interest, Schedule } = data;
            // let filterScdData = null;

            // if (Schedule.length > 0) {
            //     const SchdData = Schedule.map((item) => {
            //         const {
            //             interest,
            //             minimum_loan_amount,
            //             maximum_loan_amount,
            //             endDate,
            //             startDate,
            //             remarks1,
            //             remarks2,
            //             scheduleDate,
            //         } = item;
            //         const tempData = {
            //             interest: interest ? String(interest) : "",
            //             minimum_loan_amount: minimum_loan_amount
            //                 ? String(minimum_loan_amount)
            //                 : "",
            //             maximum_loan_amount: maximum_loan_amount
            //                 ? String(maximum_loan_amount)
            //                 : "",
            //             startDate: startDate ? dayjs(startDate).format("YYYY-MM-DD") : "",
            //             endDate: endDate ? dayjs(endDate).format("YYYY-MM-DD") : "",
            //             scheduleDate: scheduleDate
            //                 ? dayjs(scheduleDate).format("YYYY-MM-DD HH:00")
            //                 : "",
            //             remarks1: remarks1 ? remarks1 : "",
            //             remarks2: remarks2 ? remarks2 : "",
            //         };
            //         return tempData;
            //     });
            //     filterScdData = SchdData.filter((item) => item !== undefined);
            // }

            let filterScdData = [];

            if (Array.isArray(Schedule) && Schedule.length > 0) {
                const SchdData = Schedule.map((item) => {
                    const {
                        interest,
                        minimum_loan_amount,
                        maximum_loan_amount,
                        endDate,
                        startDate,
                        remarks1,
                        remarks2,
                        scheduleDate,
                    } = item;
                    return {
                        interest: interest ? String(interest) : "",
                        minimum_loan_amount: minimum_loan_amount ? String(minimum_loan_amount) : "",
                        maximum_loan_amount: maximum_loan_amount ? String(maximum_loan_amount) : "",
                        startDate: startDate ? dayjs(startDate).format("YYYY-MM-DD") : "",
                        endDate: endDate ? dayjs(endDate).format("YYYY-MM-DD") : "",
                        scheduleDate: scheduleDate ? dayjs(scheduleDate).format("YYYY-MM-DD HH:00") : "",
                        remarks1: remarks1 || "",
                        remarks2: remarks2 || "",
                    };
                });
                filterScdData = SchdData.filter((item) => item !== undefined);
            }



            const IntData = Interest.map((item, idx) => {
                const {
                    id,
                    interest,
                    minimum_loan_amount,
                    maximum_loan_amount,
                    endDate,
                    startDate,
                    remarks1,
                    remarks2,
                } = item;
                if (interest && minimum_loan_amount && startDate && remarks1) {
                    const tempData = {
                        id: id !== undefined && id !== null ? id : '',
                        interest: String(interest),
                        minimum_loan_amount: String(minimum_loan_amount),
                        maximum_loan_amount: maximum_loan_amount
                            ? String(maximum_loan_amount)
                            : "",
                        startDate: dayjs(startDate).format("YYYY-MM-DD"),
                        endDate: endDate ? dayjs(endDate).format("YYYY-MM-DD") : "",
                        remarks1: remarks1,
                        remarks2: remarks2 ? remarks2 : "",
                        schedule:
                            filterScdData.length > 0
                                ? filterScdData[idx] !== undefined
                                    ? filterScdData[idx]?.interest !== ""
                                        ? filterScdData[idx]
                                        : null
                                    : null
                                : null,
                    };
                    return tempData;
                }
            });
            const filterIntData = IntData.filter((item) => item !== undefined);
            let imgIconUrl = productIcon;
            if (croppedImage && imgIconUrl === null) {
                let blobFile = await dataURItoBlob(croppedImage);
                let formData = new FormData();
                formData.append("file", blobFile, "crop-icon.jpg");
                formData.append("module", "loanproduct");
                let fileRes = await apiAxios.post("/admin/upload/image", formData, {
                    headers: {
                        Authorization: `Bearer ${authData?.token}`,
                    },
                });
                imgIconUrl = fileRes?.data?.data;
            }

            const postData = {
                name,
                icon: imgIconUrl,
                displayFrom: null,
                displayTo: null,
                ...filterVal,
                interests: filterIntData,
                form_data: declarationFormData
            };
            console.log("postData", postData)
            if (editForm.edit) {
                console.log("true")
                const productResp = await axios.put(
                    `/loan/product/update/${editForm.id}`,
                    postData,
                    {
                        headers: {
                            Authorization: `Bearer ${authData?.token}`,
                        },
                    }
                );
                console.log("updated info==", productResp)
                console.log("updated formdata=====", JSON.parse(productResp?.data.data.form_data))

                if (productResp?.status < 400) {
                    toast.success(productResp.data?.message);
                    setsubmitBtnLoad(false);
                    setinHouseModal(false);
                    getLoanProduct(1);

                }

            } else {
                console.log("false")
                const productResp = await axios.post("/loan/product/create", postData, {
                    headers: {
                        Authorization: `Bearer ${authData?.token}`,
                    },
                });
                if (productResp?.status < 400) {
                    toast.success(productResp.data?.message);
                    setsubmitBtnLoad(false);
                    setinHouseModal(false);
                    getLoanProduct(1);

                }

            }
        }
    };
    const overRideFormdata = () => {
        setOverRideModal(!overRideModal);
        const { isExist } = checkData;
        if (isExist) {
            setEditForm({
                ...editForm,
                edit: true,
                id: checkData.id,
            });
            setFilterVal({
                ...filterVal,
                approvalTime: checkData.approvalTime,
                category: checkData.category,
                loanType: checkData.loanType,
                ltv: checkData.ltv,
                motorType: checkData.motorType,
                productType: checkData.productType,
                scheme: checkData.scheme,
                featured: checkData.featured,
                usage: checkData.usage,
                collect_first_installment:
                    checkData?.collect_first_installment !== undefined
                        ? checkData?.collect_first_installment
                        : "0",
            });
            setProductIcon(checkData.icon);
            checkData.interests.forEach((item, idx) => {
                let startDate = item.startDate ? dayjs(item.startDate) : "";
                let endDate = item.endDate ? dayjs(item.endDate) : "";
                setValue(`Interest.[${idx}].interest`, item.interest);
                setValue(`Interest.[${idx}].startDate`, startDate);
                setValue(`Interest.[${idx}].endDate`, endDate);
                setValue(`Interest.[${idx}].remarks1`, item.remarks1);
                setValue(`Interest.[${idx}].remarks2`, item.remarks2);
                setValue(
                    `Interest.[${idx}].minimum_loan_amount`,
                    item.minimum_loan_amount
                );
                setValue(`Interest.[${idx}].check_val`, item.admin_fee_status);
                setValue(`Interest.[${idx}].view`, true);
                if (item.admin_fee_status === "1") {
                    setValue(
                        `Interest.[${idx}].maximum_loan_amount`,
                        item.maximum_loan_amount
                    );
                }
                items[idx].schedDis = false;
                if (item.schedule) {
                    const schedule = item.schedule;
                    let startDate = schedule.startDate ? dayjs(schedule.startDate) : "";
                    let endDate = schedule.endDate ? dayjs(schedule.endDate) : "";
                    let scheduleDate = schedule.scheduleDate
                        ? dayjs(schedule.scheduleDate)
                        : "";
                    setValue(`Schedule.[${idx}].interest`, schedule.interest);
                    setValue(`Schedule.[${idx}].startDate`, startDate);
                    setValue(`Schedule.[${idx}].endDate`, endDate);
                    setValue(`Schedule.[${idx}].scheduleDate`, scheduleDate);
                    setValue(`Schedule.[${idx}].remarks1`, schedule.remarks1);
                    setValue(`Schedule.[${idx}].remarks2`, schedule.remarks2);
                    setValue(
                        `Schedule.[${idx}].minimum_loan_amount`,
                        schedule.minimum_loan_amount
                    );
                    setValue(`Schedule.[${idx}].check_val`, schedule.admin_fee_status);
                    setValue(`Schedule.[${idx}].view`, true);
                    if (schedule.admin_fee_status === "1") {
                        setValue(
                            `Schedule.[${idx}].maximum_loan_amount`,
                            schedule.maximum_loan_amount
                        );
                    }
                    setmakeSchedule((prevState) => ({
                        ...prevState,
                        [`scd${idx}`]: true,
                    }));
                }
            });
        }
    };

    const handleFormSave = (formData) => {
        setDeclarationFormData(formData);
        console.log("formdata====", formData)
    }

    const submitClick = () => {
        setImgErr(false);
        if (!croppedImage && productIcon === null) {
            setImgErr(true);
            if (imgPosRef.current) {
                imgPosRef.current.scrollIntoView({
                    block: "start",
                    behavior: "smooth",
                });
            }
        }
    };
    const interestTabChange = (key) => {
        setinterestKey(key);
        setIntTabPos(0);
    };
    useEffect(() => {
        if (
            Object.keys(applyFilters)?.length > 0 &&
            applyFilters !== undefined &&
            applyFilters !== null
        ) {
            setFilterVal({
                vehicle: applyFilters?.vehicle,
                category: applyFilters?.category,
                loanType: applyFilters.loanType,
                scheme: applyFilters?.scheme,
                usage: applyFilters?.usage,
                motorType: applyFilters?.motorType,
                productType: applyFilters?.productType,
                ltv: applyFilters?.ltv,
                approvalTime: applyFilters?.approvalTime,
                featured: authData?.featured,
            });
        } else {
            setFilterVal({
                ...filterVal,
                vehicle: settingsData.vehicles[0].id,
                category: settingsData.categories[0].id,
                loanType: settingsData.categories[0].types[0].id,
                scheme: settingsData.categories[0].types[0].schemes[0].id,
                usage: settingsData.productUsages[0].id,
                motorType: settingsData.productMotorTypes[0].id,
                productType: settingsData.loanProviderTypes[2].id,
                featured: authData?.featured,
                ltv: settingsData?.ltvs[0]?.id,
                approvalTime: settingsData?.approvalTimes[0]?.id,
                // ltv: authData?.ltv,
                // approvalTime: authData?.approvalTime,
            });
        }
        //setValue("name", authData?.name);
        setProductIcon(authData?.icon);
        document.querySelector("body").classList.add("body_scroll_hid");
        setAnimClass("visible translate-x-[0%]");
        return () => {
            document.querySelector("body").classList.remove("body_scroll_hid");
            setAnimClass("invisible translate-x-[100%]");
        };
    }, []);

    return (
        <div
            className={`bg-black bg-opacity-50 fixed z-[999]  w-[100%] h-full left-0 top-0`}
        >
            {showCrop ? (
                <CropPopup
                    image={image}
                    setActive={setShowCrop}
                    setImage={setCroppedImage}
                />
            ) : null}
            <Modal
                title={
                    <p className="relative bottom-[4px] text-[18px]">
                        Product already exists
                    </p>
                }
                open={overRideModal}
                okText="Yes"
                cancelText="No"
                onOk={overRideFormdata}
                onCancel={() => {
                    setinHouseModal(false);
                    setOverRideModal(!overRideModal);
                }}
            >
                <div className="py-[10px] text-[18px]">
                    Under the selected loan provider or agent, the same product is
                    available for this filter's criteria. Do you want to overwrite?
                </div>
            </Modal>
            <div
                className={`w-[730px] max-w-[100%] bg-white absolute rounded-t-lg md:rounded-none bottom-0 h-[100%] md:h-[100%] right-0 max-h-screen overflow-y-scroll scBarHidden popupAnim ${animClass}`}
            >
                <div className="relative py-2 pt-14">
                    <div className="absolute bg-white w-[100%] top-0">
                        <div className="flex px-4 py-2 pt-4 md:px-8 md:py-4 justify-between items-center z-9 w-[100%]">
                            <h3 className="text-md font-bold tracking-[-.15px] capitalize">
                                Create Loan Product
                            </h3>
                            <div
                                className="bg-gray-100 px-2 py-2 rounded-md hover:bg-gray-200 transition-all cursor-pointer"
                                onClick={() => setinHouseModal(false)}
                            >
                                <img src="/images/x-circle.svg" className="w-5 h-5" />
                            </div>
                        </div>
                    </div>
                    {pInfoFetch ? (
                        <div className="h-[calc(100vh-100px)] flex flex-col justify-center items-center">
                            <LoaderComp />
                        </div>
                    ) : (
                        <FormProvider {...methods}>
                            <form onSubmit={handleSubmit(createLoanProduct)}>
                                <div className="p-[25px_30px] max-[600px]:p-[25px_18px]">
                                    <div className="flex items-center gap-[10px] mb-[15px] max-[600px]:flex-wrap">
                                        <div className="w-[50%] max-[600px]:w-full mt-[50px]">
                                            <label
                                                className="block text-[13px] text-[#495159] mb-[6px]"
                                                ref={imgPosRef}
                                            >
                                                Product Image
                                            </label>
                                            <ImageInput
                                                error={imgErr}
                                                image={
                                                    croppedImage
                                                        ? croppedImage
                                                        : productIcon && productIcon !== ""
                                                            ? `${IMAGE_BASE_URL}/${productIcon}`
                                                            : ""
                                                }
                                                setImage={onImageChange}
                                            />
                                        </div>
                                        <div className="w-[50%] max-[600px]:w-full mt-[50px]">
                                            <label className="block text-[13px] text-[#495159] mb-[6px]">
                                                Product Name
                                            </label>
                                            <Controller
                                                control={control}
                                                name="name"
                                                rules={{
                                                    required: true,
                                                }}
                                                render={({ field }) => {
                                                    return (
                                                        <Input
                                                            {...field}
                                                            status={errors?.name ? "error" : null}
                                                            placeholder="Product Name"
                                                            className="py-[8px]"
                                                        />
                                                    );
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="flex items-center gap-[10px] mb-[5px] max-[650px]:flex-wrap">
                                        <div className="w-[50%] max-[650px]:w-full">
                                            <InHouseSwitchBox
                                                title="Vehicle"
                                                disb={editForm.edit}
                                                val={filterVal.vehicle}
                                                tabs={settingsData.vehicles}
                                                settingsHandle={settingsHandle}
                                            />
                                        </div>
                                        <div className="w-[50%] max-[650px]:w-full">
                                            <InHouseSwitchBox
                                                title="Type"
                                                disb={editForm.edit}
                                                val={filterVal.category}
                                                tabs={settingsData.categories}
                                                settingsHandle={settingsHandle}
                                            />
                                        </div>
                                    </div>
                                    <div className="flex items-center gap-[10px] mb-[5px] max-[650px]:flex-wrap">
                                        <div className="w-[50%] max-[650px]:w-full">
                                            <InHouseSwitchBox
                                                title="Category"
                                                disb={editForm.edit}
                                                val={filterVal.loanType}
                                                tabs={settingsData.categories[settingsIndex.cat].types}
                                                settingsHandle={settingsHandle}
                                            />
                                        </div>
                                        <div className="w-[50%] max-[650px]:w-full">
                                            <InHouseSwitchBox
                                                title="Motor"
                                                disb={editForm.edit}
                                                val={filterVal.motorType}
                                                tabs={settingsData.productMotorTypes}
                                                settingsHandle={settingsHandle}
                                            />
                                        </div>
                                    </div>
                                    <div className="flex items-center gap-[10px] mb-[5px] max-[650px]:flex-wrap">
                                        <div className="w-[50%] max-[650px]:w-full">
                                            <InHouseSwitchBox
                                                title="Usage"
                                                disb={editForm.edit}
                                                val={filterVal.usage}
                                                tabs={settingsData.productUsages}
                                                settingsHandle={settingsHandle}
                                            />
                                        </div>
                                        <div className="w-[50%] max-[650px]:w-full">
                                            <InHouseSwitchBox
                                                title="Scheme"
                                                disb={editForm.edit}
                                                val={filterVal.scheme}
                                                tabs={
                                                    settingsData.categories[settingsIndex.cat].types[
                                                        settingsIndex.typ
                                                    ].schemes
                                                }
                                                settingsHandle={settingsHandle}
                                            />
                                        </div>

                                    </div>
                                    <div className="flex items-center gap-[10px] mb-[5px] max-[650px]:flex-wrap">

                                        <div className="w-[50%] max-[650px]:w-full">
                                            <label className="block text-[13px] text-[#878B91] mb-[10px]">
                                                Listing Type
                                            </label>
                                            <div className="rounded-[4px] bg-[#F5F5F5] p-[3px] inline-block">
                                                <ButtonBase disabled={authData?.featured == 0}>
                                                    <span
                                                        className={`p-[5px_14px] text-[#263238] cursor-pointer rounded-[4px] text-[12px] singleSwitch ${authData?.featured && "active"
                                                            }`}
                                                    >
                                                        Featured
                                                    </span>
                                                </ButtonBase>
                                            </div>
                                        </div>

                                        <div className="w-[50%] max-[650px]:w-full">
                                            <InHouseSwitchBox
                                                title="Collect First Installment?"
                                                disb={editForm.edit}
                                                val={filterVal?.collect_first_installment}
                                                tabs={settingsData.collect_first_installment_options?.map(
                                                    (it) => {
                                                        return {
                                                            ...it,
                                                            id: it.value,
                                                        };
                                                    }
                                                )}
                                                settingsHandle={settingsHandle}
                                            />
                                        </div>
                                    </div>
                                    <div className="flex justify-between items-center mb-[10px]">
                                        <Tabs
                                            items={items}
                                            defaultActiveKey={interestKey}
                                            onChange={interestTabChange}
                                        />
                                        <Button
                                            type="button"
                                            className="sav_btn"
                                            onClick={() => setShowDeclarationModal(true)}
                                        >
                                            Add Declaration
                                        </Button>
                                    </div>
                                    {items.map((item, idx) => {
                                        if (idx === interestKey) {
                                            return (
                                                <div key={idx}>
                                                    <div className={`switch_tab inline-block mt-[5px]`}>
                                                        <div className="rounded-[4px] bg-[#F5F5F5] p-[3px] flex">
                                                            {["Current", "Scheduled"].map((tab, idx) => {
                                                                return (
                                                                    <ButtonBase
                                                                        key={idx}
                                                                        disabled={idx === 1 && item.schedDis}
                                                                    >
                                                                        <span
                                                                            className={`switch ${intTabPos === idx && "active"
                                                                                }`}
                                                                            onClick={() => setIntTabPos(idx)}
                                                                        >
                                                                            {tab}
                                                                        </span>
                                                                    </ButtonBase>
                                                                );
                                                            })}
                                                        </div>
                                                    </div>
                                                    {intTabPos === 0 ? (
                                                        <InHouseInterestBox index={idx} tabsF={items} />
                                                    ) : (
                                                        <>
                                                            {!makeSchedule[`scd${idx}`] ? (
                                                                <div className="h-[300px] flex flex-col justify-center items-center">
                                                                    <p className="text-[13px] text-[#5F7585] font-[500] mb-[13px]">
                                                                        Seems like you don’t have any schedule
                                                                    </p>
                                                                    <Button
                                                                        type="button"
                                                                        className="sav_btn"
                                                                        onClick={() =>
                                                                            setmakeSchedule({
                                                                                ...makeSchedule,
                                                                                [`scd${idx}`]: true,
                                                                            })
                                                                        }
                                                                    >
                                                                        Schedule Now
                                                                    </Button>
                                                                </div>
                                                            ) : (
                                                                <InHouseScheduleBox index={idx} />
                                                            )}
                                                        </>
                                                    )}
                                                </div>
                                            );
                                        }
                                        return null;
                                    })}
                                    <div className="mt-[25px]">
                                        <Button
                                            type="submit"
                                            className="sav_btn"
                                            onClick={submitClick}
                                            disabled={submitBtnLoad}
                                        >
                                            {submitBtnLoad && (
                                                <CircularProgress
                                                    size={20}
                                                    style={{ color: "white" }}
                                                    className="mr-[13px]"
                                                />
                                            )}
                                            {editForm.edit
                                                ? "Update Loan Product"
                                                : "Create Loan Product"}
                                        </Button>
                                        <Button
                                            type="button"
                                            className="can_btn"
                                            onClick={() => setinHouseModal(false)}
                                        >
                                            Cancel
                                        </Button>
                                    </div>
                                </div>
                            </form>
                        </FormProvider>
                    )}
                </div>
            </div>
            <AddDeclarationModal
                agentId={agentId}
                open={showDeclarationModal}
                handleSave={handleFormSave}
                declarationFormData={declarationFormData}
                onClose={() => setShowDeclarationModal(false)}
            />
        </div>

    );
};

export default InHouseModal;
